import Cookies from "js-cookie";
const dominName = process.env.NODE_ENV == "development" ? null : ".myroki.com";
export function getAccessToken() {
  return Cookies.get("access_token");
}
export function setAccessToken(token, expires) {
  return Cookies.set("access_token", token, {
    expires: expires,
    // sameSite: "None",
    // secure: true,
    domain: dominName
  });
}
export function removeAccessToken() {
  return Cookies.remove("access_token", { path: "/", domain: dominName });
}
export function getRefreshToken() {
  return Cookies.get("refresh_token");
}
export function setRefreshToken(token, expires) {
  return Cookies.set("refresh_token", token, {
    expires: expires,
    // sameSite: "None",
    // secure: true,
    domain: dominName
  });
}
export function removeRefreshToken() {
  return Cookies.remove("refresh_token", { path: "/", domain: dominName });
}



// WEBPACK FOOTER //
// ./src/utils/auth.js